<mat-toolbar color="primary">
  <mat-toolbar-row class="">
    <span>{{ toolbarTitle }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto">
      <mat-icon (click)="!loading ? closeDialogue() : ''">close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container-fluid accordion-container" *ngIf="data?.entity">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">1</span>
            {{ "generic.details" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-card class="my-5">
          <mat-card-content class="px-3">
            <ng-container *ngIf="data.type === 'action'">
              <mat-form-field class="w-100">
                <mat-label>{{
                    "generic.description" | translate
                  }}</mat-label>
                <textarea matInput class="w-100" placeholder="{{ 'generic.description' | translate }}" [(ngModel)]="data.entity.action.description" name="description" rows="3" disabled></textarea>
              </mat-form-field>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.version' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.version }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'pages.ckm-simulations.effort' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.effort_cost }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.created_at' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.created_at | date:'medium' }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.updated_at' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.updated_at | date:'medium' }}</span>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="data.type === 'event'">
              <mat-form-field class="w-100">
                <mat-label>{{
                    "generic.description" | translate
                  }}</mat-label>
                <textarea matInput placeholder="{{ 'generic.description' | translate }}" [(ngModel)]="data.entity.event.description" name="description" rows="5" disabled></textarea>
              </mat-form-field>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.version' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.version }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'pages.ckm-simulations.probability' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.probability }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.type' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.type }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.desiderability' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.desirability }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.created_at' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.created_at | date:'medium' }}</span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>{{ 'generic.updated_at' | translate }}:</strong>
                  <span class="ms-1"> {{ data.entity.updated_at | date:'medium' }}</span>
                </div>
              </div>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>


<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">2</span>
            Evidence Confidence Table – Strategic Snapshot
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="my-5 mat-elevation-z8">
          <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>

            <!-- Source Column -->
            <ng-container matColumnDef="source">
              <th mat-header-cell *matHeaderCellDef> Source </th>
              <td mat-cell *matCellDef="let element"> {{element.source}} </td>
            </ng-container>

            <!-- Nature Column -->
            <ng-container matColumnDef="nature">
              <th mat-header-cell *matHeaderCellDef> Nature </th>
              <td mat-cell *matCellDef="let element"> {{element.nature}} </td>
            </ng-container>

            <!-- Evidence Summary Column -->
            <ng-container matColumnDef="evidence">
              <th mat-header-cell *matHeaderCellDef> Evidence Summary </th>
              <td mat-cell *matCellDef="let element"> {{element.evidence}} </td>
            </ng-container>

            <!-- Risk of Bias Column -->
            <ng-container matColumnDef="bias">
              <th mat-header-cell *matHeaderCellDef> Risk of Bias </th>
              <td mat-cell *matCellDef="let element"> {{element.bias}} </td>
            </ng-container>

            <!-- Evidence Confidence Column -->
            <ng-container matColumnDef="confidence">
              <th mat-header-cell *matHeaderCellDef> Evidence Confidence </th>
              <td mat-cell *matCellDef="let element">
                <span [ngClass]="element.confidence.toLowerCase()">{{element.confidence}}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <div class="row justify-content-center" *ngIf="!epistemicShowed && !loading">
          <button
            (click)="launchEpistemic()"
            class="size-small danger text-white mb-5 mt-3"
            mat-flat-button
          >
            Launch Epistemic Review
          </button>
        </div>

        <div class="d-flex justify-content-center my-5" *ngIf="loading">
          <mat-progress-spinner
            diameter="30"
            strokeWidth="4"
            mode="indeterminate"
          ></mat-progress-spinner>
        </div>


        <div *ngIf="epistemicShowed" class="my-5 mat-elevation-z8 w-100">
          <table mat-table [dataSource]="dataSourceSecond" class="mat-table w-100">

            <!-- Source Column -->
            <ng-container matColumnDef="source">
              <th mat-header-cell *matHeaderCellDef> Source </th>
              <td mat-cell *matCellDef="let el"> {{el.source}} </td>
            </ng-container>

            <!-- Type of Evidence Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> Type of Evidence </th>
              <td mat-cell *matCellDef="let el"> {{el.type}} </td>
            </ng-container>

            <!-- Recency Column -->
            <ng-container matColumnDef="recency">
              <th mat-header-cell *matHeaderCellDef> Recency </th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngFor="let star of getStars(el.recency)">
                  <mat-icon>{{ star }}</mat-icon>
                </ng-container>
              </td>
            </ng-container>

            <!-- Cross-Sourced Corroboration -->
            <ng-container matColumnDef="corroboration">
              <th mat-header-cell *matHeaderCellDef> Cross-Sourced Corroboration </th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngFor="let star of getStars(el.corroboration)">
                  <mat-icon>{{ star }}</mat-icon>
                </ng-container>
              </td>
            </ng-container>

            <!-- Contextual Alignment -->
            <ng-container matColumnDef="alignment">
              <th mat-header-cell *matHeaderCellDef> Contextual Alignment </th>
              <td mat-cell *matCellDef="let el">
                <mat-icon [ngClass]="getAlignmentClass(el.alignment)">check_circle</mat-icon>
                {{ el.alignment }}
              </td>
            </ng-container>


            <!-- Epistemic Strength -->
            <ng-container matColumnDef="strength">
              <th mat-header-cell *matHeaderCellDef> Epistemic Strength </th>
              <td mat-cell *matCellDef="let el">
                <span [ngClass]="el.strength.toLowerCase()">{{ el.strength }}</span>
              </td>
            </ng-container>

            <!-- Header and Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumnsSecond"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSecond;"></tr>
          </table>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">3</span>
            {{ "components.decision-table.decision-table-dashboard.evidence-attached" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="my-5">

          <mat-table [dataSource]="biblioSearchDataSource" matSort>
            <!-- Definizione delle colonne -->
            <ng-container matColumnDef="articleTitle">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.articleTitle }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="authors">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Authors</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.authors }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="year">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Year</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.year }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="studyType">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Study Type</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.studyType }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="mainOutcome">
              <mat-header-cell *matHeaderCellDef>Main Outcome</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.mainOutcome }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="riskOfBias">
              <mat-header-cell *matHeaderCellDef>Risk of Bias</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.riskOfBias }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="consistency">
              <mat-header-cell *matHeaderCellDef>Consistency</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.consistency }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="precision">
              <mat-header-cell *matHeaderCellDef>Precision</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.precision }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="gradeQuality">
              <mat-header-cell *matHeaderCellDef>Grade Quality</mat-header-cell>
              <mat-cell *matCellDef="let article">{{ article.gradeQuality }}</mat-cell>
            </ng-container>

            <!-- Header e righe della tabella -->
            <mat-header-row *matHeaderRowDef="biblioSearchDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: biblioSearchDisplayedColumns;"></mat-row>
          </mat-table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
